export default "__VITE_ASSET__D8KAUfT0__"